// extracted by mini-css-extract-plugin
module.exports = {"dg200":"dg200_dg200__jgTMV"};